import React, { useEffect, useMemo, useRef } from 'react';
import { useThread } from '../../Data/Thread';
import Loading from '../Loading';
import Message from './Message';
import Reply from './Reply';
import { useVisibilityChange } from '../../Services/helpers';
import API from '../../Services/API';
import Toggle from '../Button/Toggle';
import { usePreference } from '../../Data/Preference';

const TheThread = ({threadId, disabled}) => {
    const [includeNotificationLogs, setIncludeNotificationLogs] = usePreference('thread:notificationLogs', true);
    const { thread, isSaving, isLoading, addReply, refresh } = useThread(threadId, true, includeNotificationLogs);
    const scrollRef = useRef();

    useEffect(() => {
        if (scrollRef?.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [thread?.messages?.length]);

    useEffect(() => {
        if (thread && thread?.messages) {
            markMessagesAsRead(thread.messages);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [thread?.messages]);

    const lastNonSystemMessageId = useMemo(() => {
        if (!thread?.messages) {
            return null;
        }
        return thread.messages.filter(m => !!m.direction).pop()?.id;
    }, [thread?.messages]);

    useVisibilityChange(refresh);

    const handleAddReply = async (data) => {
        await addReply(data);
        // Refresh again in a moment to hopefully pick up the deferred notification
        if (includeNotificationLogs) {
            setTimeout(() => {
                refresh();
            }, 1000);
        }
    }

    if (!thread) {
        return <Loading size="2x" center />;
    }

    return <>
        <div className="flex flex-col mb-3">
            <div className="flex flex-col max-h-[50vh] overflow-y-scroll" ref={scrollRef}>
                {thread.messages.map((message, index) => <Message key={message.id}
                    message={message}
                    nextIsSameDirection={index < thread.messages.length-1 && message.direction === thread.messages[index+1].direction}
                    isLast={message.id === lastNonSystemMessageId}
                    refreshThread={refresh}
                />)}
                {thread.messages.length === 0 && <p className="py-3 text-muted text-center">No messages</p>}
            </div>
        </div>
        <Reply saving={isSaving} onReply={handleAddReply} thread={thread} disabled={disabled} />
        <Toggle
            label="Show notifications and broadcasts"
            enabled={includeNotificationLogs}
            onChange={x => setIncludeNotificationLogs(x)}
            className="my-3"
            loading={isLoading}
            ring
        />
    </>
}

const markMessagesAsRead = (messages) => {
    const unread = messages.filter((m) => m.direction === 'Inbound' && m.seenByBusinessAt === null);
    const first = unread.shift()
    if (first) {
        API.post('messages/see', { threadId: first.threadId, messageId: first.id }).then(res => {
            markMessagesAsRead(unread)
        }).catch(errors => {
            console.error(errors)
        });
    }
}


export default TheThread;
